export const getRoundPoints = teamRound => {
  /*
  Adds up the points for each question in the round to get the total
  */
  return teamRound.team_questions.reduce((acc, item) => acc + item.points, 0)
}
